import { useContext } from "react";
import { ComparablesLayerContext } from "./ComparableLayerContext";

export const useComparablesLayerContext = () => useContext(ComparablesLayerContext);
